import { ClipLoader } from 'react-spinners';
import { SOCKET_URL } from '../../core/constants/urls';
import { formatNumber } from '../../core/utils/common';
import Text from '../../core/utils/Text';

export default function InternalTransferInvoice({
	invoice,
	closeInvoice,
	makeTransfer,
	isTransfering,
}) {
	const handleSubmit = () => {
		makeTransfer({
			toId: invoice.toId,
			currency: invoice.currency,
			amount: invoice.amount,
			note: invoice.note,
		});
	};

	return (
		<div className='w-full max-w-md mx-auto rounded-2xl bg-white shadow-lg dark:bg-gray-800 text-white relative'>
			{/* Header */}
			<div className='flex justify-center items-center px-4 py-2 h-[67px] bg-black h-full rounded-t-2xl w-full'>
				<h2 className='text-lg font-semibold  text-center'>
					<Text tid='internal-transfer-invoice' />
				</h2>
			</div>

			{/* Invoice Details */}
			<div className='space-y-2 p-6 text-black dark:text-white'>
				<div className='flex justify-between items-center border-b border-b-gray-[#818DB7] py-2'>
					<span className='opacity-70'>
						<Text tid='coin' />
					</span>
					<div className='flex items-center gap-x-2'>
						<img
							src={
								invoice.currency === 'irt'
									? require('../../assets/images/tooman.png')
									: `${SOCKET_URL}assets/icon/${invoice.currency}.png`
							}
							width={24}
							height={24}
							alt={invoice.currency}
						/>
						<span>{invoice.currency.toUpperCase()}</span>
					</div>
				</div>

				<div className='flex justify-between items-center border-b border-b-gray-[#818DB7] py-2'>
					<span className='opacity-70'>
						<Text tid='amount' />
					</span>
					<span>{formatNumber(invoice.amount)} {invoice.currency.toUpperCase()}</span>
				</div>

				<div className='flex justify-between items-center border-b border-b-gray-[#818DB7] py-2'>
					<span className='opacity-70'>
						<Text tid='receiver-id' />
					</span>
					<span>{invoice.toId}</span>
				</div>

				<div className='flex justify-between items-center border-b border-b-gray-[#818DB7] py-2'>
					<span className='opacity-70'>
						<Text tid='receiver-username' />
					</span>
					<span>{(invoice.to.firstName || '-') + ' ' + (invoice.to.lastName || '-')}</span>
				</div>

				<div className='flex justify-between items-center border-b border-b-gray-[#818DB7] py-2'>
					<span className='opacity-70'>
						<Text tid='transaction-fee-1' />
					</span>
					<span>{formatNumber(invoice.wage)} {invoice.currency.toUpperCase()}</span>
				</div>

				<div className='flex justify-between items-center'>
					<span className='opacity-70'>
						<Text tid='amount-to-pay' />
					</span>
					<span>{formatNumber(invoice.finalAmount)} {invoice.currency.toUpperCase()}</span>
				</div>
			</div>

			{/* Buttons */}
			<div className='flex justify-center gap-4 p-4'>
				<button
					className='bg-active w-1/2 py-2 rounded-lg flex items-center justify-center gap-x-2 text-white font-semibold'
					onClick={handleSubmit}
					disabled={isTransfering}
				>
					{isTransfering ? (
						<>
							<Text tid='doing' />
							<ClipLoader size={15} color={'#fff'} />
						</>
					) : (
						<Text tid='submit-transfer' />
					)}
				</button>

				<button
					className='bg-transparent w-1/2 text-sm text-gray-900 dark:text-white font-semibold border rounded-lg border-active'
					onClick={closeInvoice}
				>
					<Text tid='previous-step' />
				</button>
			</div>
		</div>
	);
}
